// @flow
import * as React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import { colors } from '../theme';

const List = styled.ul`
  flex-wrap: wrap;
  list-style-type: none;
  padding-left: 0;
  color: ${colors.greyishBrown};
  li::before {
    content: '•';
    color: ${colors.waterBlue};
    display: inline-block;
    width: 1em;
  }
`;

const BulletList = ({
  items,
  columns = 1,
  itemMargin = 0,
  ...props
}: {
  items: Array<{ key: string | number, value: React.Node }>,
  columns?: 1 | 2,
  itemMargin?: number,
  'data-qa-id'?: string
}) => (
  <Box component={List} classes={['flex']} mb={`-${itemMargin}px`} {...props}>
    {items.map(
      ({ key, value }) =>
        value && (
          <Box
            component="li"
            key={key}
            width={[1, 1, 1, 1 / columns]}
            mb={`${itemMargin}px`}
          >
            {value}
          </Box>
        )
    )}
  </Box>
);

export default BulletList;
